import React from 'react';
import moment from 'moment';
import { createSum } from '../../lib/sumUtils';

const PaidContent = ({ paymentState, amount, paidTime }) => {
  const topContent = [
    paymentState?.name || 'Оплачено',
    createSum({ sum: amount }),
  ]
    .filter(Boolean)
    .join(' - ');

  return (
    <>
      <span>{topContent}</span>
      {Boolean(paidTime) && (
        <span>{moment(paidTime).format('DD.MM.YYYY HH:mm')}</span>
      )}
    </>
  );
};

export default PaidContent;
